export const uk = {
    'esli-u-vas-est-param-link': 'сообщите об этом нам',
    'operator-comment': 'Комментарий от оператора',
    'oshibki-ustraneny-nuzhna-povtornaya-100': 'Ошибки устранены, нужна повторная проверка объявления',
    'ostalis-drugie-voprosy-po': 'Остались другие вопросы по сервису',
    'ostalis-voprosy-o-prichinah': 'Остались вопросы о причинах отклонения',
    'ostavit-zayavku-na-vozvrat': 'Оставить заявку на возврат средств',
    'otpravit-dokumenty': 'Отправить документы',
    'polnyy-spisok-trebovaniy': 'Полный список требований',
    'popup-title': 'Как исправить',
    'ubedites-chto-reklamnye-materialy':
        'Убедитесь, что рекламные материалы соответствуют {yandex} и {law}. Уделите особое внимание требованиям к изображениям, ключевым словам и быстрым ссылкам.',
    'ubedites-chto-reklamnye-materialy-param-law': 'действующему законодательству',
    'ubedites-chto-reklamnye-materialy-param-yandex': 'рекламной политике Яндекса'
};
